import React from 'react';
import { motion } from 'framer-motion';

const VIEWPORT = { once: true, margin: '-80px' };
const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={VIEWPORT}
    transition={{ duration: 0.7, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SlideLeft = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={VIEWPORT}
    transition={{ duration: 0.75, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SlideRight = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, x: 50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={VIEWPORT}
    transition={{ duration: 0.75, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const ScalePop = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, scale: 0.85 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={VIEWPORT}
    transition={{ duration: 0.55, ease: [0.34, 1.56, 0.64, 1], delay }}
  >
    {children}
  </motion.div>
);

export const CountUp = ({ to = 100, duration = 1800, suffix = '', className }) => {
  const [val, setVal] = React.useState(0);
  const [started, setStarted] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !started) {
          setStarted(true);
          const start = performance.now();
          const tick = (now) => {
            const p = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setVal(Math.round(to * eased));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [to, duration, started]);

  return (
    <span ref={ref} className={className}>
      {val}
      {suffix}
    </span>
  );
};
